import { OperationVariables } from '@apollo/client';
import { set } from 'lodash/fp';
import { useQuery } from '@apollo/client/react';

import { GET_BLOG_POST } from '../../../../cms/queries/blog-queries.gql';
import { GetArticleQuery, Maybe } from '../../../../types/__codegen__/sanity/graphql';
import uniqueContentWithDraftPrecedence from '../../../../cms/utils/unique-content-with-draft-precedence';

type UseGetArticleParams = {
  slug?: Maybe<string> | undefined;
  options: useQuery.Options<GetArticleQuery, OperationVariables>;
};

const useGetArticle = ({ options, slug }: UseGetArticleParams) => {
  const updatedOptions = set('variables.identifier', slug, options);
  const { data, loading: isLoading, error } = useQuery(GET_BLOG_POST, updatedOptions);
  const articles = uniqueContentWithDraftPrecedence(data?.allArticle);
  return { data: articles, error, isLoading };
};

export default useGetArticle;
